import React from "react";
import { Dimensions, StyleSheet } from "react-native";
import AppButton from "./AppButton";

function MultipleEntryButton({ title, entries, onPress }) {
  const containsEntry = entries.includes(title);
  return (
    <AppButton
      style={[styles.button]}
      title={title}
      color={containsEntry ? "green" : "white"}
      textColor={containsEntry ? "white" : "black"}
      onPress={onPress}
    />
  );
}

const styles = StyleSheet.create({
  button: {
    marginLeft: 20,
    marginRight: 20,
    marginVertical: 8,
    alignSelf: "center",
    width:
      window.innerWidth <= 760
        ? 0.7 * Dimensions.get("window").width
        : 0.3 * Dimensions.get("window").width,
    padding: 20,
  },
});

export default MultipleEntryButton;
